import React from 'react'
import * as UI from '@/components/UI'
import { SmallText } from '@/components/UI/Typography/Typography'
import {
  Section,
  Grid,
  BodyCell,
  Body,
  Title,
  SidebarCell,
  Sidebar,
  SidebarTitle,
  List,
  Item,
  WrapperSidebarCell,
} from './TemplateAbout.css'

const SeriousGamesTemplateAbout = ({ content, color = 'blue', variant }) => {
  return (
    <Section>
      <UI.Container>
        <Grid>
          <BodyCell>
            <Title>{content.about_title}</Title>
            <Body
              dangerouslySetInnerHTML={{ __html: content.about_body.html }}
            />
          </BodyCell>
          {variant === 'portfolio' &&
          (content.about_sidebar_section_title1 ||
            content.about_sidebar_section_title2) ? (
            <WrapperSidebarCell>
              <SidebarCell style={{ width: '100%' }}>
                <Sidebar>
                  <SidebarTitle>
                    {content.about_sidebar_section_title1}
                  </SidebarTitle>
                  <SmallText>
                    {content.about_sidebar_section_description1}
                  </SmallText>
                </Sidebar>
              </SidebarCell>
              <SidebarCell style={{ width: '100%' }}>
                <Sidebar style={{ marginTop: '32px' }}>
                  <SidebarTitle>
                    {content.about_sidebar_section_title2}
                  </SidebarTitle>
                  <SmallText>
                    {content.about_sidebar_section_description2}
                  </SmallText>
                </Sidebar>
              </SidebarCell>
            </WrapperSidebarCell>
          ) : (
            <SidebarCell>
              <Sidebar>
                <SidebarTitle>{content.about_sidebar_title}</SidebarTitle>
                {content.about_sidebar_list.length && (
                  <List>
                    {content.about_sidebar_list.map(({ item }) => (
                      <Item color={color}>{item}</Item>
                    ))}
                  </List>
                )}
              </Sidebar>
            </SidebarCell>
          )}
        </Grid>
      </UI.Container>
    </Section>
  )
}

export default SeriousGamesTemplateAbout
